export default __webpack_public_path__ + "static/media/Pilgrim's Hood of the Eldritch.3db94fab.jpg";